import { DefaultSeo } from "next-seo";
import type { ComponentProps } from "react";
import { useRouter } from "next/router";
import { HEAD_PROPERTY_TEMPLATE } from "~/components/blocks/vod/top/const";
import { COPY_RIGHT } from "~/const/meta";
import { PATHS } from "~/const/paths";
import { useMatchMedia } from "~/hooks/use-match-media";

type MetaTags = ComponentProps<typeof DefaultSeo>["additionalMetaTags"];
type MetaTag = NonNullable<MetaTags>[number];

export default function DefaultHead() {
  const { asPath } = useRouter();
  const isAdultPage = asPath.startsWith(PATHS.VOD_GRAVURE);
  const { isSpSize } = useMatchMedia();
  // TODO(uchida): useMatchMediaを使わずに書き直せるか調べる
  const viewportContent = isSpSize
    ? "width=device-width,initial-scale=1.0,viewport-fit=cover,maximum-scale=1.0,user-scalable=no"
    : "width=device-width,initial-scale=1.0,viewport-fit=cover,user-scalable=no";
  const ratingTagIfNeed: MetaTag[] = isAdultPage
    ? [
        {
          name: "rating",
          content: "adult",
        },
      ]
    : [];

  return (
    <DefaultSeo
      title={HEAD_PROPERTY_TEMPLATE.VOD_TOP.TITLE}
      description={HEAD_PROPERTY_TEMPLATE.VOD_TOP.DESCRIPTION}
      canonical=""
      openGraph={{
        title: "",
        description: "",
        images: [
          {
            url: "https://imgsrc.dmm.com/dig/dmmtv/etc/ogp/dmmtvOgp.jpg",
            width: 1200,
            height: 630,
          },
        ],
        siteName: "DMM TV",
        locale: "ja_JP",
        type: "website",
        url: "",
      }}
      twitter={{ cardType: "summary_large_image", site: "@DMMTV_PR" }}
      additionalMetaTags={[
        ...ratingTagIfNeed,
        { name: "copyright", content: COPY_RIGHT },
        {
          name: "viewport",
          content: viewportContent,
        },
      ]}
      additionalLinkTags={[
        { rel: "icon", href: "/favicon-light.ico", media: "(prefers-color-scheme: light)" },
        { rel: "icon", href: "/favicon-dark.ico", media: "(prefers-color-scheme: dark)" },
        {
          rel: "apple-touch-icon",
          sizes: "180x180",
          href: "https://imgsrc.dmm.com/dig/dmmtv/etc/apple-touch-icon/dmmtv.png",
        },
        {
          rel: "preconnect",
          href: "https://awsimgsrc.dmm.com/",
        },
        {
          rel: "preconnect",
          href: "https://www.googletagmanager.com/",
        },
        {
          rel: "preconnect",
          href: `${process.env.NEXT_PUBLIC_DMM_SERVICE_ENDPOINT}`,
        },
        {
          rel: "preconnect",
          href: `${process.env.NEXT_PUBLIC_TRACKING_ENDPOINT}`,
        },
      ]}
    />
  );
}
